module.exports = __webpack_public_path__ + "media/images/firstview/top_mask_type/cover1-eedf7c24ab8746a000b259bb531e7eb2.svg";